var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcurement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5L14.5834 9.58334L10 6.66668V12.5ZM2.50004 18.3333C2.04171 18.3333 1.64935 18.1701 1.32296 17.8438C0.996569 17.5174 0.833374 17.125 0.833374 16.6667V7.50001H2.50004V16.6667H16.6667V18.3333H2.50004ZM5.83337 15C5.37504 15 4.98268 14.8368 4.65629 14.5104C4.3299 14.184 4.16671 13.7917 4.16671 13.3333V4.16668H8.33337V2.50001C8.33337 2.04168 8.49657 1.64932 8.82296 1.32293C9.14935 0.996538 9.54171 0.833344 10 0.833344H13.3334C13.7917 0.833344 14.1841 0.996538 14.5105 1.32293C14.8368 1.64932 15 2.04168 15 2.50001V4.16668H19.1667V13.3333C19.1667 13.7917 19.0035 14.184 18.6771 14.5104C18.3507 14.8368 17.9584 15 17.5 15H5.83337ZM10 4.16668H13.3334V2.50001H10V4.16668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcurement);
export default __webpack_public_path__ + "static/media/procurement.7f333ce8d6827bdda3f735f08dc7c642.svg";
export { ForwardRef as ReactComponent };